import { AxiosInstance } from 'axios';
import { apiRequest } from './apiRequest';
import { ApiResponse } from './types';

export interface BillingInfo {
  first_name: string;
  last_name: string;
  email: string;
  country: string;
  name: string; // full name
  address: string;
  state: string;
  zipcode: string;
  city: string;
  phone: string;
  house_number: string;
  address2?: string;
}

export interface GetPaymentFormUrlRequest {
  customer_id: string;
  provider_id: string;
  redirect_uri: string;
  billing_info?: BillingInfo;
}

export interface GetPaymentFormUrlResponse {
  url: string;
}

export type GetPaymentFormUrl = (
  data: GetPaymentFormUrlRequest
) => Promise<ApiResponse<GetPaymentFormUrlResponse>>;

const getPaymentFormUrl = (api: AxiosInstance): GetPaymentFormUrl => {
  return async (data: GetPaymentFormUrlRequest): Promise<ApiResponse<GetPaymentFormUrlResponse>> => {
    return apiRequest<GetPaymentFormUrlResponse>(api, {
      method: 'POST',
      url: '/api/custom-booking/payment-form',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  };
};

export default getPaymentFormUrl;